import Icon from '../components/Icon.vue'

Icon.register({
  chalkboard: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M96 64v352h-64v-376c0-22.1 17.9-40 40-40h496c22.1 0 40 17.9 40 40v376h-64v-352h-448zM624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h272v-64h192v64h144z'
      }
    ]
  }
})
